<div class="reset-password__content">
  <app-logo></app-logo>
  <h2 class="reset-password__title title-xl">
    {{ 'SET_NEW_PASSWORD_L' | translate }}
  </h2>

  <app-set-password-form
    (submitPassword)="submit($event)"
    [ctaButtonLabel]="'general.submit_password_a'"
  ></app-set-password-form>

  @if (error$ | async) {
    <app-message [messageType]="'error'">
      <div>{{ error$ | async }}</div>
    </app-message>
  }
</div>
